import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { canAccess } from 'helpers/adminPermissions';
import { rememberNewsletterRedirect } from 'helpers/newsletter';

const DeniedRedirect = () => {
  useEffect(() => {
    toast.error('Você não tem acesso a essa funcionalidade', {
      toastId: 'admin-route-denied',
    });
  }, []);

  return <Redirect to="/dashboard" />;
};

const RouteWithLayout = ({
  layout: Layout,
  component: Component,
  isPrivate,
  permission,
  permissionAction,
  ...rest
}) => {
  const data = useSelector((state) => state.auth);
  const { path } = rest;
  let signed = false;
  if (data.token && data.signed === true) {
    signed = true;
  } else {
    signed = false;
  }

  if (!signed && isPrivate) {
    rememberNewsletterRedirect(window.location.pathname);
    return <Redirect to="/" />;
  }
  if (signed && !isPrivate && path !== '/not-found') {
    return <Redirect to="/dashboard" />;
  }
  if (signed && !canAccess(data, permission, permissionAction)) {
    return <DeniedRedirect />;
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
  isPrivate: PropTypes.bool,
  permission: PropTypes.string,
  permissionAction: PropTypes.oneOf(['view', 'create', 'edit', 'delete']),
};

RouteWithLayout.defaultProps = {
  isPrivate: false,
  permissionAction: 'view',
};

export default RouteWithLayout;
